export const BreadcrumbWidgetId = 'BreadcrumbWidget';

export enum BreadcrumbWidgetAttributes {
  MAX_ITEMS = 'maxItems',
  ITEMS_BEFORE_COLLAPSE = 'itemsBeforeCollapse',
  ITEMS_AFTER_COLLAPSE = 'itemsAfterCollapse',
}
